<template>
  <div >
    <div class="tags-mini">
      <v-chip
        class="chip-with-hover-remove text-center"
        v-for="tag in value"
        :key="tag.tagGuid + tag.tagBackgroundColor + tag.tagTextColor"
        :style="{
          backgroundColor: $vuetify.theme.dark ? tag.tagTextColor : tag.tagBackgroundColor,
          color: $vuetify.theme.dark ? tag.tagBackgroundColor : tag.tagTextColor,
          userSelect: 'none'
        }"
      >
       <div class="ms-1">{{ tag.tagName }}</div> 

        <v-icon
          :title="$t('remove')"
          v-if="isRemovable"
          small
          class="ma-0 pa-0 remove-icon"
          @click="unselectTag(tag)"
        >
          mdi-close
        </v-icon>
      </v-chip>
       <v-menu
      v-if="showAdd"
      offset-y
      :close-on-content-click="false"
      :nudge-top="-5"
      :nudge-left="-5"
      :nudge-right="-5"
      :max-width="300"
      :min-width="200"
      :transition="'slide-y-transition'"
      ref="tagItemMenu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip label v-bind="attrs" v-on="on" @click="search='';getTagItems()" small class="pa-1 mt-1">
          <v-icon style="user-select: none;"  :title="$t('portfolio.TagsItem.addNew')">
            mdi-plus
          </v-icon>
        </v-chip>
      </template>
      <v-card flat class="pa-2">
        <v-text-field
          v-model="search"
          :placeholder="$t('search')"
          class="mx-2 my-1"
          dense
          hide-details
          outlined
        />
        <div style="max-height: 250px; overflow-y: auto;">
          <v-list dense>
            <v-list-item
              v-for="(i, index) in getTagsItemsList"
              :key="i.tagGuid + i.tagBackgroundColor + i.tagTextColor + i.tagItemGuid"
            >
              <v-chip
                @click="
                  value.some(tag => tag.tagItemGuid === i.tagItemGuid)
                    ? unselectTag(i)
                    : selectTag(i)
                "
                class="text-truncate px-2"
                :style="{
                  backgroundColor: $vuetify.theme.dark ? i.tagTextColor : i.tagBackgroundColor,
                  color: $vuetify.theme.dark ? i.tagBackgroundColor : i.tagTextColor,
                  width: '100%',
                  cursor: 'pointer',
                  justifyContent: 'center'
                }"
              >
                <v-icon
                  v-if="value.some(tag => tag.tagItemGuid === i.tagItemGuid)"
                  small
                  right
                  class="mx-2"
                >
                  mdi-check
                </v-icon>
                {{ i.tagName }}
              </v-chip>

              <v-icon
                :title="$t('edit')"
                class="mx-2"
                @click="$refs.tagItemDialog.showDialogEdit(i)"
              >
                mdi-pen
              </v-icon>
            </v-list-item>
          </v-list>
        </div>
        <v-card-actions class="ma-0">
          <v-btn
            depressed
            style="width: 100%;"
            color="primary"
            @click="$refs.tagItemDialog.showDialog()"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            {{ $t("portfolio.TagsItems.createNewTag") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    </div>

   
    <TagItemDialog
      ref="tagItemDialog"
      @update="updateTag"
      @delete="removeTag"
      @success="updateTagsAll"
    />
  </div>
</template>

<script>
import TagItemDialog from "@/components/portfolio/TagsItem/tagItemDialog.vue";

export default {
  components: {
    TagItemDialog
  },
  data() {
    return {
      tagItems: [],
      search: ""
    };
  },
  name: "TagsMini",
  props: {
    sourceGuid: {
      type: String,
      required: true
    },
    sourceType: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    isRemovable: {
      type: Boolean,
      default: false
    },
    showAdd: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  created() {
    //this.getTagItems();
    // this.getTags();
  },
  computed: {
    getTagsItemsList() {
      return this.tagItems.filter(i => i.tagName.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  methods: {
    async getTagItems() {
      await this.axios
        .get("TagItem/Get")
        .then(res => {
          this.tagItems = res.data.data;
        })
        .catch(error => {
          console.error("Error fetching tags:", error);
        });
    },
    async updateTagsAll() {
      // this.getTags()
      this.getTagItems();
    },
    removeTag(tagItem) {
      const tIndex = this.tagItems.findIndex(i => i.tagItemGuid === tagItem);
      if (tIndex === -1) return;
      this.tagItems.splice(tIndex, 1);
      const index = this.value.findIndex(x => x.tagItemGuid === tagItem);
      this.$emit("delete", index);
      this.$emit("input", this.value.filter(tag => tag.tagItemGuid !== tagItem));
    },
    selectTag(item) {
      const req = {
        sourceGuid: this.sourceGuid,
        sourceType: this.sourceType,
        tagItemGuid: item.tagItemGuid
      };

      this.axios
        .post("Tag/Create", req)
        .then(res => {
          const tag = {
            tagName: item.tagName,
            tagBackgroundColor: item.tagBackgroundColor,
            tagTextColor: item.tagTextColor,
            sourceGuid: this.sourceGuid,
            sourceType: this.sourceType,
            tagItemGuid: item.tagItemGuid,
            tagGuid: res.data
          };
          this.$emit("addTag", tag);
          this.$emit("input", [...this.value, tag]);
          this.getTagItems();
        })
        .catch(error => {
          console.error("Error adding tag:", error);
          this.$swal.fire({
            title: this.$t("AnErrorOccurredDuringTheProcess"),
            text: "",
            icon: "error",
            confirmButtonText: this.$t("close")
          });
        });
    },
    unselectTag(item) {
      const req = {
        tagGuid: this.value.find(tag => tag.tagItemGuid === item.tagItemGuid).tagGuid
      };
      console.log("Removing tag:", req);

      this.axios
        .post("Tag/Delete", req)
        .then(() => {
          this.$emit(
            "removeTag",
            req.tagGuid
          );
          this.$emit("input", this.value.filter(tag => tag.tagItemGuid !== item.tagItemGuid));
          this.getTagItems();
        })
        .catch(error => {
          console.error("Error removing tag:", error);
        });
    },
    updateTag(tagItem) {
      const index = this.tagItems.findIndex(i => i.tagItemGuid === tagItem.tagItemGuid);
      if (index !== -1) Object.assign(this.tagItems[index], tagItem);
      const tagIndex = this.value.findIndex(t => t.tagItemGuid === tagItem.tagItemGuid);
      if (tagIndex !== -1)
        Object.assign(this.value[tagIndex], {
          tagName: tagItem.tagName,
          tagBackgroundColor: tagItem.tagBackgroundColor,
          tagTextColor: tagItem.tagTextColor
        });
      this.$emit("input", this.value);
    }
  }
};
</script>

<style scoped>
.chip-with-hover-remove .remove-icon {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.chip-with-hover-remove:hover .remove-icon,
.chip-with-hover-remove:focus .remove-icon {
  opacity: 1;
}
</style>
<style scoped>
.tags-mini {
  display: flex;     
  flex-wrap: wrap;
  gap: 8px;
}
</style>
